import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getItem, setItem } from "../../../utils/storageHelper";

// Action Types - The thunk will generate these automatically
// You can remove these if you use the builder syntax in your reducer
export const IMPORT_TIMETABLE_FROM_URL_SUCCESS = "api/Calendar/importTimetableFromUrl/fulfilled";
export const IMPORT_TIMETABLE_FROM_URL_ERROR = "api/Calendar/importTimetableFromUrl/rejected";

// Thunk Action Creator
export const importTimetableFromUrl = createAsyncThunk(
    "api/Calendar/importTimetableFromUrl",
    async (url, { rejectWithValue }) => {
        try {
            const providerType = await getItem("calendarProvider");

            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/import/url/${providerType}`,
                { url: url },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            // createAsyncThunk automatically handles dispatching the success action
            // with the returned payload.
            if (response.status == 200)
            {
                if (response.data === '') {
                    throw new Error("Problem importing the timetable. Logging the user out");
                } else {
                    // ✅ FIX: Use async getItem instead of localStorage for Capacitor compatibility
                    const calendarIdsString = await getItem("calendar");
                    const calendarIds = calendarIdsString ? JSON.parse(calendarIdsString) : {};

                    let ids = calendarIds;
                    if (!ids.MyTimetable && response.data.items && response.data.items.length > 0) {
                        ids.MyTimetable = response.data.items[0].extendedProperties.private.calendarId;
                        await setItem("calendar", JSON.stringify(ids));
                    }
                }
            }
            return response.data;

        } catch (error) {
            // This will cause the thunk to return a rejected promise
            console.error('Error in importTimetableFromUrl:', error);
            return rejectWithValue(error.message);
        }
    }
);